/**
 * Copyright 2022 IBM Corp.
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 **/

import Marquee from "react-fast-marquee";

export default function MQMessageList ({messages = []}) {
    return (
        <Marquee>
            {
                messages.map((msg,i) => {
                    if (msg.Message && msg.Count) {
                        return (
                            <span key={'f' + i}>
                                {msg.Message} - {msg.Count} &nbsp;
                            </span>
                            );
                    } else {
                        return (
                            <span key={'s'+ i}>
                                <pre>{JSON.stringify(msg, null, 2)}</pre>
                            </span>    
                        )
                    }
                })
            }
        </Marquee>
    )
}